export default __webpack_public_path__ + "static/media/connect-email-icon.9985aff8.png";